module.exports = __webpack_public_path__ + "static/ch7-SCRUB-03-e06b8c223b5c242edf4f126e9d474f62.mp4";